import { IntlDate, IntlCurrency } from "us.common/functions";
import { ExcelValueFormatType } from "../Constants";
/**
 * @function
 * @description Get formatted value for column
 * @param value - value to be formatted
 * @param valueType - formatting type
 * @param format - format type
 * @returns formatted value.
 */
const formatter = (value: any, valueType: ExcelValueFormatType, format: any): any => {
  let result;
  switch (valueType) {
    case ExcelValueFormatType.CURRENCY:
      result = IntlCurrency(
        value,
        format?.currentLanguage,
        format?.currentCurrency
      );
      break;
    case ExcelValueFormatType.DATE:
      result = IntlDate(
        value,
        format?.currentLanguage,
        format?.currentDateFormat
      );
      break;
    case ExcelValueFormatType.TEXT:
      result = value ?? "";
      break;
    default:
      result = value ?? "";
  }
  return result;
};

/**
 * @function
 * @description Get columns
 * @param {Array<any>} data - Data to get columns
 * @param {Array<any>} columns - Columns to be formatted
 * @param {any} format - column format
 * @returns formatted columns.
 */
export const columnDataGenerator = (
  data: Array<any>,
  columns: Array<any>,
  format: any
): Array<any> => {
  try {
    let columnData: any = [];
    let formattedColumns: any = [];
    data?.map((dataRecord: any) => {
      formattedColumns = [];
      columns?.map((column: any) => {
        const { dataIndex, config, format: columnFormat } = column ?? {};
        if (column?.hasOwnProperty("config")) {
          if (eval(`${dataRecord[dataIndex]}${config[dataIndex]}`)) {
            formattedColumns?.push({
              value: formatter(dataRecord[dataIndex], columnFormat, format),
            });
          } else {
            formattedColumns?.push({
              value: "",
            });
          }
        } else {
          formattedColumns?.push({
            value: formatter(dataRecord[dataIndex], columnFormat, format),
          });
        }
      });
      columnData?.push(formattedColumns);
    });
    return columnData;
  } catch (err) {
    return [];
  }
};
